<template>
    <div class="mapswiper">
      <div style="width: 100%;height: 100%;position: relative;overflow: hidden;">
        <div style="font-weight: 600;font-size: 16px;text-align: start;">{{ imgList.title }}</div>
        <div style="font-size: 12px;text-align: start;width: 65%;">{{ imgList.content }}</div>
        <img @click="$emit('sendData',false)" style="position: absolute;top: 0px;right: 0px;width: 35px;" src="@/assets/btn/close.png" alt="">
        <div class="swiper-button-prev" style="left: 5%;top: 45%;"><img src="@/assets/btn/left1.png" alt=""></div>
        <div class="swiper-button-next" style="right:5%;top: 45%;"><img src="@/assets/btn/right1.png" alt=""></div>
        <swiper class="swiper swipertop" :options="swiperTop" ref="swiperTop" >
          <swiper-slide  v-for="item,i in imgList.imglist" :key="i" >
            <img ondragstart="return false;" :src="item.logo" alt="">
          </swiper-slide>
        </swiper>
        <swiper class="swiper swiperbottoms" :options="swiperBottom" ref="swiperBottom" >
          <swiper-slide  v-for="item,j in imgList.imglist" :key="j">
            <img ondragstart="return false;" :src="item.logo" alt=""  @click="handleSlideClick(j)">
          </swiper-slide>
        </swiper>
      </div>
      <!-- <img style="position: absolute;top: 10px;right: 10px;background-color: white;width: 35px;z-index: 120;" src="@/assets/btn/close.png"> -->

    </div>

</template>

<script>
export default {
  name: 'MapSwiper',
  data() {
    return {
      swiperBottom:{
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        slidesPerView: 7,
        loopedSlides: 1, // looped slides should be the same
        // loop:true,
        spaceBetween: 10, 
        centeredSlides : true,
        // direction: 'vertical',
      },
      swiperTop: {
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 4, // looped slides should be the same
        // spaceBetween: 10,
        // centeredSlides : true,
        // loop:true,
        autoplay: {
            delay: 3000, // 轮播间隔时间，单位为毫秒
            disableOnInteraction: false, // 用户操作后是否禁止自动轮播
          },
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
        },

        },
    }
  },
  props:{
    imgList:{
      type:Array,
      default:{}
    }
  },
  methods:{
    handleSlideClick(index) {
      // 切换到指定索引的 slide
      console.log(index);
      this.$refs.swiperBottom.swiper.slideTo(index);
    },
    padZero(num, length) {
    return String(num).padStart(length, '0');
    }
  },
  mounted(){
    this.$nextTick(()=>{
      const top = this.$refs.swiperTop.swiper
      const bottom = this.$refs.swiperBottom.swiper
      top.controller.control = bottom
      bottom.controller.control = top
    })
  }
}
</script>

<style lang="less">

.mapswiper{
  position: relative;
  width: 80%;
  height: 80%;
  background-color: white;
  padding: 20px;
  z-index: 301;
  border-radius: 10px;
  color: black;
}
.swipertop{
  position: absolute;
  left: 0;
  top: 10%;
  width: 100%;
  height: 79%;
  // background-color: rgba(255, 255, 255, 0.151);
  // border-radius: 10px;
  .swiper-slide{
    img{
        object-fit: contain;
        height: 100%;
        width: 100%;
    }
  }
}
.swiperbottoms{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 10%;
  // border-radius: 10px;
  .swiper-slide{
    img{
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
  }
}
.swiper-slide{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    // border-radius: 10px;
    // background-color: #000000;
}
.swiper-button-prev,.swiper-button-next{
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  img{
    max-height: 5rem;
    max-width: 5rem;
  }
}
</style>

